import {ActivityIndicator} from '@unthinkable/react-activity-indicator';
import {useFilter} from '@unthinkable/react-filters';
import {useToast} from '@unthinkable/react-toast';
import React, {useState} from 'react';
import images from 'src/assets/images';
import {AutoCompleteFilter} from 'src/components/filter/Filters';
import {TableHeader} from 'src/components/header/TableHeader';
import {Icon} from 'src/components/icon';
import {Table} from 'src/components/table';
import Config from 'src/Config';
import {routeLink} from 'src/constant';
import {action, entity} from 'src/constant/authorization';
import {Medication_Log_Status} from 'src/constant/status';
import {useAuth} from 'src/modules/auth/hooks/useAuth';
import {HttpAuthService} from 'src/services';
import checkAuthorization from 'src/services/accessService';
const MedicationLogs = () => {
  const {onChangeFilter, filterValues} = useFilter();
  const {user} = useAuth();
  const [loading, setLoading] = useState(-1);
  const toast = useToast();

  const options = [
    {
      label: 'Pending',
      value: Medication_Log_Status.pending,
    },
    {
      label: 'Validation Report Not Found',
      value: Medication_Log_Status.validationReportNotFound,
    },
    {
      label: 'Validation Error',
      value: Medication_Log_Status.validationError,
    },
    {
      label: 'Combined Response Not Found',
      value: Medication_Log_Status.combinedResponseNotFound,
    },
    {
      label: 'Data Not Found',
      value: Medication_Log_Status.dataNotFound,
    },
    {
      label: 'Medication Response Not Found',
      value: Medication_Log_Status.MedicationResponseNotFound,
    },
    {
      label: 'Successful',
      value: Medication_Log_Status.successful,
    },
    {
      label: 'Partial Success',
      value: Medication_Log_Status.partialSuccess,
    },
  ];

  const downloadHandler = async ({row}) => {
    try {
      setLoading(row._id);
      await HttpAuthService.download(
        routeLink.downloadMedicationRequestResponse,
        {
          params: {
            filter: {
              _id: row._id,
            },
          },
        },
      );
    } catch (err) {
      console.log(err);
      toast({
        type: 'Error',
        message: `${err?.message || err || ''}`,
      });
    } finally {
      setLoading(-1);
    }
  };

  const renderDownload = ({row}) => {
    if (loading === row._id) {
      return <ActivityIndicator />;
    }
    return (
      <Icon
        src={images.ArrowDownBlack}
        onClick={async () => {
          await downloadHandler({row});
        }}
      />
    );
  };
  return (
    <Table
      renderHeader={() => {
        return (
          <TableHeader
            actions={[
              <AutoCompleteFilter
                onChangeFilter={onChangeFilter}
                filterValues={filterValues}
                field={'status'}
                suggestionField={'label'}
                keyField={'value'}
                options={options}
                key={'statusFilter'}
                placeholder={'Status'}
              />,
            ]}
          />
        );
      }}
      limit={Config.defaultListLimit}
      api={routeLink.medicationRequest}
      addOnFilter={JSON.stringify(filterValues.filter)}
      sort={{
        createdAt: -1,
      }}
      fields={{
        patientQuery: {
          filename: 1,
          key: 1,
          contentType: 1,
        },
        validationResponse: {
          fileName: 1,
          key: 1,
          contentType: 1,
        },
        combinedResponse: {
          fileName: 1,
          key: 1,
          contentType: 1,
        },
        medicationHistory: {
          fileName: 1,
          key: 1,
          contentType: 1,
        },
        status: 1,
        totalNumberOfRecords: 1,
        successFullyProcessed: 1,
        failedToProcess: 1,
        responseFetchDateTime: 1,
        createdAt: 1,
      }}
      columns={[
        {
          header: 'FileName',
          field: 'patientQuery.filename',
          type: 'text',
        },
        {
          header: 'Uploaded At',
          field: 'createdAt',
          type: 'date',
          formatOptions: {
            format: Config.dateFormat,
          },
        },
        {
          header: 'Number Of Records',
          field: 'totalNumberOfRecords',
          type: 'text',
          width: 100,
        },
        {
          header: 'Successfully Processed',
          field: 'successFullyProcessed',
          type: 'text',
          width: 100,
        },
        {
          header: 'Failed To Process',
          field: 'failedToProcess',
          type: 'text',
          width: 100,
        },
        {
          header: 'Status',
          field: 'status',
          type: 'text',
          width: 150,
        },
        {
          header: 'Next Attempt',
          field: 'responseFetchDateTime',
          type: 'date',
          formatOptions: {
            format: Config.dateFormat,
          },
          width: 150,
        },
        {
          render: renderDownload,
          visible: () =>
            checkAuthorization(user, entity.medicationLogs, action.download),
          width: 50,
        },
      ]}
    />
  );
};

export default MedicationLogs;
